import React, { useState, useCallback, useEffect, useMemo, ReactNode } from "react"
import { Configure, InfiniteHits, SearchBox } from "react-instantsearch";
import CustomSearchBox from "./CustomSearchBox";
import CustomInfiniteHits from "./CustomInfiniteHits";
import liteClient from 'algoliasearch/lite';
import CustomStats from "./CustomStats"
// import { Icon } from "trimble-terra/Icon"
import { Icon } from "trimble-terra"
import { InstantSearchNext } from "react-instantsearch-nextjs";
import "./BlogArticleSearch.css";

interface BlogArticleSearchProps {
  locale?: any, 
  articleSearchModalOpen?: any,
  setArticleSearchModalOpen?: any,
  title?: string,
  description?: string,
  eyebrow?: string,
  quickLinks?: any,
  resultsText?: string,
  searchPlaceholderText?: string,
  resetButtonText?: string,
  topSearchesLabel?: string,
  quickLinksLabel?: string,
  searchTerm?: string,
  algoliaData?: {
    algoliaId: string,
    algoliaKey: string,
    algoliaIndex: string,
    algoliaHits: number
  }
  profile?: any
}

const BlogArticleSearch = ({  
  locale, 
  articleSearchModalOpen,
  setArticleSearchModalOpen,
  title,
  description,
  eyebrow,
  quickLinks,
  resultsText,
  searchPlaceholderText,
  resetButtonText,
  topSearchesLabel,
  quickLinksLabel,
  searchTerm,
  algoliaData,
  profile
  } : BlogArticleSearchProps) => {
  const crawlerIndex = algoliaData?.algoliaIndex || "trimble-resource-center";
  const hitsPerPage = algoliaData?.algoliaHits ? algoliaData?.algoliaHits : 10
  const hitsPerIndex = hitsPerPage && (hitsPerPage / 2);

  const clientId = algoliaData?.algoliaId;
  const clientKey = algoliaData?.algoliaKey;
  const searchClient = (clientId && clientKey) ? liteClient(clientId, clientKey) : null;

  const [currentRefinement, setCurrentRefinement] = useState("")

  useEffect(() => {
    const htmlElem = document?.documentElement?.classList
    if (articleSearchModalOpen) {
      // obscure scrollbar on open of search takeover
      htmlElem.add("ter-app--scroll-locked")
    }
    return () => htmlElem.remove("ter-app--scroll-locked")
  }, [articleSearchModalOpen])


  useEffect(() => {
    setCurrentRefinement(searchTerm || "");
  }, [searchTerm])

  const clearSearch = useCallback(() => {
    setCurrentRefinement("")
  }, [])

  const resetClick = () => {
    clearSearch()
  }

  const closeClickHandler = () => {
    setArticleSearchModalOpen(false);
  }

  if (searchClient == null) {
    return null
  }

  let searchFacetFilter = `lang:${locale} AND (contentType:${"Article"})`
  if(profile.NEXT_PUBLIC_RC_TYPE === "resources") {
    searchFacetFilter = `lang:${locale} AND (contentType:${"Video"} OR contentType:${"Document"} OR contentType:${"CaseStudy"})`
  }
  return (
    <>
      <div className={`blog-article-search__wrapper ${articleSearchModalOpen ? 'blog-article-search__wrapper--deployed' : ''} `}>
        <InstantSearchNext indexName={crawlerIndex} searchClient={searchClient}>
          <div className="blog-article-search__hero max-w-xl t2-wrapper">
            <>
              <div className="blog-article-search__hero__grid">
                <div className="blog-article-search__hero__grid__column">
                  <div className="blog-article-search__hero__eyebrow">{eyebrow}</div>
                  <h1 className="blog-article-search__hero__title">{title}</h1>
                  <p className="blog-article-search__hero__description">
                    {description}
                  </p>
                </div>
                <button
                    onClick={(e) => {
                      closeClickHandler()
                    }}
                    className="t2-icon t2-icon--close t2-icon--42px blog-article-search__close-button"
                    aria-label={"Close search"}
                  >
                    <Icon type="t2u-close" size={24} />
                  </button>
              </div>
              <div className="blog-article-search__search-box">
                <div className="blog-article-search__search-box__wrapper">
                  <CustomSearchBox
                    searchText={currentRefinement}
                    setSearchText={setCurrentRefinement}
                    searchPlaceholderText={searchPlaceholderText}
                  />
                  {resetClick && (
                    <button
                      className="blog-article-search__reset-text"
                      onClick={resetClick}
                      aria-label="Reset search"
                    >
                      {resetButtonText}
                    </button>
                  )}
                </div>
              </div>
            </>
          </div>
          <div className="blog-article-search__results max-w-xl t2-wrapper">
              <div className="blog-article-search__results__grid">
                <div className="blog-article-search__results__column">
                  {currentRefinement?.length >= 2 ? (
                    <>
                      <CustomStats
                        resultsText={resultsText}
                        currentRefinement={currentRefinement}
                      />
                        <Configure
                          hitsPerPage={hitsPerIndex}
                          filters={searchFacetFilter}
                          clickAnalytics
                        />
                        <CustomInfiniteHits
                          minHitsPerPage={hitsPerIndex}
                          locale={locale}
                        />
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
          </div>
        </InstantSearchNext>
      </div>
    </>
  )
}

export default BlogArticleSearch
